import React from "react";
import styles from "./HumanLikeVoiceEngine.module.css";
import {
    Waves,
    Mic,
    Zap,
    Phone,
    Heart,
    Smile,
    Frown,
    MessageCircle,
    Bolt,
    Volume2,
    Meh,
    HelpCircle
} from "lucide-react";

import demoImage from "../../../Images/chatbot_img2.png"; // replace with your image

const features = [
    { icon: <Waves />, label: "Advanced Speech Recognition" },
    { icon: <Mic />, label: "Natural Text-to-Speech" },
    { icon: <Zap />, label: "Real-Time Interruption Handling" },
    { icon: <Phone />, label: "Warm Transfer" },
];

const emotions = [
    { icon: <Heart />, label: "Multiple Emotional Tones" },
    { icon: <Smile />, label: "Laughing" },
    { icon: <Frown />, label: "Angry" },
    { icon: <MessageCircle />, label: "Neutral" },
    { icon: <Bolt />, label: "Excited" },
    { icon: <Volume2 />, label: "Shouting" },
    { icon: <Meh />, label: "Sad" },
    { icon: <MessageCircle />, label: "Whisper" },
    { icon: <HelpCircle />, label: "Confused" },
    { icon: <Smile />, label: "Happy" },
];

const HumanLikeVoiceEngine = () => {
    return (
        <section className={styles.section}>
            <span className={styles.badge}>Powered by Vox</span>

            <h2 className={styles.heading}>
                The Most Human-Like Voice Engine
            </h2>

            <p className={styles.subheading}>
                Vox is our flagship TTS model that delivers studio-quality speech with
                emotional intelligence. Natural pauses, filler words, and breathing
                patterns make every conversation feel genuinely human.
            </p>

            <div className={styles.mainGrid}>
                {/* LEFT */}
                <div className={styles.left}>
                    {features.map((item, i) => (
                        <div
                            key={i}
                            className={styles.featureCard}
                            style={{ animationDelay: `${i * 0.1}s` }}
                        >
                            <div className={styles.icon}>{item.icon}</div>
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>

                {/* RIGHT */}
                <div className={styles.right}>
                    <img src={demoImage} alt="Voice Engine" />
                </div>
            </div>

            {/* EMOTIONS */}
            <div className={styles.emotionGrid}>
                {emotions.map((item, i) => (
                    <div
                        key={i}
                        className={styles.emotionCard}
                        style={{ animationDelay: `${i * 0.05}s` }}
                    >
                        <div className={styles.emotionIcon}>{item.icon}</div>
                        <span>{item.label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HumanLikeVoiceEngine;